import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MixpanelEvents } from '@services/mixpanel/types';

type EventMap = {
  [eventName in MixpanelEvents]: boolean;
};

const mixpanelSlice = createSlice({
  name: 'mixpanelStore',
  initialState: {} as EventMap,
  reducers: {
    toggleOn: (state, action: PayloadAction<MixpanelEvents>) => {
      state[action.payload] = true;
    },
    toggleOff: (state, action: PayloadAction<MixpanelEvents>) => {
      state[action.payload] = false;
    },
  },
});

export const { toggleOn, toggleOff } = mixpanelSlice.actions;

export const { reducer: mixpanelReducer } = mixpanelSlice;
